import LazyLoad from 'vanilla-lazyload';

const initLazyLoad = new LazyLoad();
initLazyLoad.update();

const sliderNav = document.querySelector('.slider-nav');
const slideNavItems = sliderNav.querySelectorAll('li');
const slideNavLinks = sliderNav.querySelectorAll('span');
const logoGroups = document.querySelectorAll('.logo-group');
let currentLogosGroup = 0;
let nextLogosGroup = 0;

// Set the slider nav active class and width

/**
 * Calculates the width and position of the navigation element based on the provided link.
 *
 * @param {HTMLElement} link - The link element used as a reference for calculating the navigation width and position.
 * @param {HTMLElement} nav - The navigation element to be styled.
 * @param {string} [prefix="nav"] - The prefix used for CSS custom properties.
 */

function calculateNavWidth(link, nav, prefix = 'nav') {
	nav.style.setProperty(`--${prefix}Transform`, `${link.offsetLeft}px`);
	nav.style.setProperty(`--${prefix}Width`, `${link.offsetWidth}px`);
}

// This function will change the active logo group
// and animate the logos in and out

const changeGroup = () => {
	const outgoingGroup = logoGroups[currentLogosGroup];
	currentLogosGroup = nextLogosGroup;
	const incomingGroup = logoGroups[nextLogosGroup];

	outgoingGroup.classList.add('outgoing');

	const outgoingLogos = outgoingGroup.querySelectorAll('.logo-wrap');
	outgoingLogos.forEach((logo, index) => {
		setTimeout(() => {
			const currentLogo = logo;
			currentLogo.style.opacity = '0';
			currentLogo.style.transform = 'translateY(-20px)';
		}, index * 50);
	});

	setTimeout(() => {
		outgoingGroup.classList.remove('active', 'outgoing');
	}, 500);

	incomingGroup.classList.add('active');
	const incomingLogos = incomingGroup.querySelectorAll('.logo-wrap');
	incomingLogos.forEach((logo, index) => {
		setTimeout(() => {
			const currentLogo = logo;
			currentLogo.style.opacity = '1';
			currentLogo.style.transform = 'translateY(0)';
		}, index * 100);
	});
};

// Initialize: Set initial active state and width
calculateNavWidth(slideNavLinks[0], sliderNav, 'nav');

// Initial setup to show the first group immediately
logoGroups[0].classList.add('active');
logoGroups[0].querySelectorAll('.logo-wrap').forEach((logo) => {
	logo.style.opacity = '1';
	logo.style.transform = 'translateY(0)';
});

// Recalculate the slider nav on window resize
window.addEventListener('resize', () => {
	const activeLink = sliderNav.querySelector('li.active-slide span');
	if (activeLink) {
		calculateNavWidth(activeLink, sliderNav, 'nav');
	}
});

// Auto-rotate carousel every 2 seconds
let currentSlideIndex = 0;
setInterval(() => {
	currentSlideIndex = (currentSlideIndex + 1) % slideNavItems.length;
	slideNavItems.forEach((item) => item.classList.remove('active-slide'));
	slideNavItems[currentSlideIndex].classList.add('active-slide');
	calculateNavWidth(slideNavLinks[currentSlideIndex], sliderNav, 'nav');
	nextLogosGroup = currentSlideIndex;
	changeGroup();
}, 2000);
